import { IInsuranceBenefitCoverages } from '../interfaces/benefits';

export const BENEFITS_USAGE_MOCK = {
  startDate: '2022-09-01',
  endDate: '2022-09-26',
  collaborators: 168,
  usageByPeriod: [
    {
      startDate: '2022-09-01',
      endDate: '2022-09-07',
      collaborators: 40
    },
    {
      startDate: '2022-09-08',
      endDate: '2022-09-15',
      collaborators: 60
    },
    {
      startDate: '2022-09-16',
      endDate: '2022-09-23',
      collaborators: 45
    },
    {
      startDate: '2022-09-24',
      endDate: '2022-10-01',
      collaborators: 75
    }
  ],
  usageByCategory: {
    wellness: [
      {
        providerName: 'Hanufit',
        imageUrl: 'https://e1gcfheg.directus.app/assets/0b2d53e6-fbe4-40fe-b056-ae02275808ee',
        providerId: 19,
        benefitId: 37,
        benefitName: {
          es: 'Entrenamiento Físico',
          en: 'Physical training',
          pt: 'Treinamento fisico'
        },
        collaborators: 108
      },
      {
        providerName: 'Hanufit',
        imageUrl: 'https://e1gcfheg.directus.app/assets/73fdf7fd-6739-4fa5-8c43-a46502c7f8ea',
        providerId: 1,
        benefitId: 2,
        benefitName: {
          es: 'Alimentación saludable',
          en: 'Healthy nutrition',
          pt: 'Alimentação saudável'
        },
        collaborators: 108
      }
    ],
    health: [
      {
        providerName: 'Teledoc',
        imageUrl: 'https://e1gcfheg.directus.app/assets/b8a5bdb4-41aa-4fdc-8abf-a548d008540c',
        providerId: 1,
        benefitId: 3,
        benefitName: {
          es: 'Atención médica 24/7',
          en: '24/7 medical attention',
          pt: 'Atendimento médico 24 horas'
        },
        collaborators: 39
      }
    ],
    education: [
      {
        providerName: 'The big know',
        imageUrl: 'https://e1gcfheg.directus.app/assets/24c92c77-343e-4413-9c9f-60488b7f8e76',
        providerId: 1,
        benefitId: 4,
        benefitName: {
          es: 'Educación de bienestar',
          en: 'wellness education',
          pt: 'educação de bem-estar'
        },
        collaborators: 39
      }
    ],
    finance: [
      {
        providerName: 'SoyFocus',
        imageUrl: 'https://e1gcfheg.directus.app/assets/41012c4c-7fed-4bc7-bdf0-933677cebc9a',
        providerId: 1,
        benefitId: 5,
        benefitName: {
          es: 'Ahorro personalizado',
          en: 'personalized savings',
          pt: 'economia personalizada'
        },
        collaborators: null
      }
    ],
    legal: [
      {
        providerName: 'Legal Chile',
        imageUrl: 'https://e1gcfheg.directus.app/assets/b18676e3-b467-4a1f-ab2f-124ef5fde209',
        providerId: 1,
        benefitId: 6,
        benefitName: {
          es: 'Asesoría legal',
          en: 'Legal advice',
          pt: 'Acessoria legal'
        },
        collaborators: 39
      }
    ],
    custom: [
      {
        providerName: 'Los shoros',
        imageUrl: 'https://media.elmostrador.cl/2016/02/Flaitos.jpg',
        providerId: 1,
        benefitId: 6,
        benefitName: {
          es: 'Asesoría legal',
          en: 'Legal advice',
          pt: 'Acessoria legal'
        },
        collaborators: 1843,
        benefitDescription: {
          es: 'Puro talento',
          en: 'Just talent',
          pt: 'Talento puro'
        },
        isCustom: true
      }
    ]
  }
};

export const BENEFITS_MONTHS_MOCK = [
  ['2022-09-01', '2022-09-31'],
  ['2022-08-01', '2022-08-31'],
  ['2022-07-01', '2022-07-31']
];

export const BENEFIT_USAGE_MOCK = {
  collaborators: 12,
  sessions: 23,
  minutes: null,
  bettercoinEarned: null
};

export const AVAILABLE_BENEFITS_HOLDING_MOCK = [
  { 16: ['CUSTOM'] },
  { 18: [] },
  { 275: [] },
  { 485: ['CUSTOM', 1, 2] },
  { 462: ['CUSTOM'] },
  { 504: ['CUSTOM'] },
  { 58: ['CUSTOM'] },
  { 572: ['CUSTOM'] }
];

export const BENEFITS_BY_PLAN_MOCK = {
  standard: [
    {
      benefitId: '892',
      sku: 'headspace',
      subSourceType: undefined,
      sourceType: 'wellbeing',
      title: 'Meditación',
      providerName: 'Headspace',
      icon: 'https://static.techbetterfly.com/benefits/provider/logo_8efadcfd.png',
      category: 'wellbeing'
    },
    {
      benefitId: '2476',
      sku: 'conexa-clinic-mega',
      subSourceType: undefined,
      title: 'Telemedicina',
      sourceType: 'wellbeing',
      providerName: 'Conexa',
      icon: 'https://static.techbetterfly.com/benefits/provider/logo_bb1c8825.png',
      category: 'health'
    },
    {
      benefitId: '2839',
      sku: 'icatu-health-BR-start',
      subSourceType: undefined,
      title: 'Protege tu salud',
      sourceType: 'insurance',
      providerName: 'Icatu',
      icon: 'https://static.techbetterfly.com/benefits/provider/logo_14762ee1.png',
      category: 'health'
    }
  ],
  bfc: {},
  bfu: {
    benefits: [
      {
        benefitId: '2116',
        sku: 'cla-benefits-CL-common',
        subSourceType: null,
        title: 'Beneficios Caja los Andes',
        providerName: 'Caja Los Andes',
        icon: 'https://static.techbetterfly.com/benefits/provider/logo_4ab4675a.png',
        category: 'wellbeing'
      },
      {
        benefitId: '3169',
        sku: 'meetingpros-vets',
        subSourceType: null,
        title: 'Telemdicina veterinaria',
        providerName: 'Meeting Vets',
        icon: 'https://static.techbetterfly.com/benefits/provider/logo_3de69e66.png',
        category: 'education'
      },
      {
        benefitId: '3136',
        sku: 'meetingpros-doctors',
        subSourceType: 'telemedicine',
        title: 'Telemedicina',
        providerName: 'Meeting Doctors',
        icon: 'https://static.techbetterfly.com/benefits/provider/logo_7a185061.png',
        category: 'education'
      },
      {
        benefitId: '7789',
        sku: 'medismart-CL-0U.GEN.PSI.VET',
        subSourceType: 'telemedicine',
        title: 'Telemedicina',
        providerName: 'Medismart',
        icon: 'https://static.techbetterfly.com/benefits/provider/logo_42b15a66.png',
        category: 'health'
      },
      {
        benefitId: '7822',
        sku: 'medismart-CL-2U.GEN.PSI.VET',
        subSourceType: 'telemedicine',
        title: 'Telemedicina',
        providerName: 'Medismart',
        icon: 'https://static.techbetterfly.com/benefits/provider/logo_8f5e843f.png',
        category: 'health'
      }
    ],
    availableChoices: 6
  }
};

export const INSURANCE_BENEFIT_COVERAGES_MOCK: IInsuranceBenefitCoverages = {
  pdfUrl: 'https://static.techbetterfly.com/insurance_covers/vida_basic_cl.pdf?response-content-disposition=inline',
  coverages: [
    {
      id: 'e52d10e9-4a86-4915-9ce4-ada698be1cd3',
      name: 'Accidental death',
      description: 'Apoyo economico para la compra de anteojos y/o protesis recetados',
      type: 'coverage',
      currency: 'UF',
      baseAmount: 20.0,
      coveragePercentage: null,
      icon: '',
      numberEvents: 'None'
    },
    {
      id: '916d29a4-2d42-4e20-a3c8-d676da09315f',
      name: 'Natural death',
      description: 'descripcion',
      type: 'coverage',
      currency: 'UF',
      baseAmount: 10.0,
      coveragePercentage: null,
      icon: '',
      numberEvents: 'None'
    },
    {
      id: 'ea842845-331a-43c1-afc9-94947353ffdb',
      name: 'Accidental disability',
      description: 'EN_COBERTURA',
      type: 'coverage',
      currency: 'UF',
      baseAmount: 10.0,
      coveragePercentage: 10.0,
      icon: '',
      numberEvents: 'None'
    }
  ]
};
